export interface ApplicationVersionResponse {
    name: string;
    version: string;
    status: "OK";
}
